export default __webpack_public_path__ + "static/kota-privacy-1e5736fd4e29374c1960d777f4301850.pdf";